exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".igUPbReAe1niLlwtLhnaU.unlocked .react-draggable{cursor:move}.igUPbReAe1niLlwtLhnaU.locked .react-resizable-handle{display:none}.igUPbReAe1niLlwtLhnaU .react-grid-placeholder{background:#16ace3}.igUPbReAe1niLlwtLhnaU .actions{cursor:default}", ""]);

// exports
exports.locals = {
	"reactGridLayout": "igUPbReAe1niLlwtLhnaU"
};